import React, { useCallback, useEffect, useState } from 'react';
import AppContext from 'Utils/AppContext';
import { API } from '../../Auth';
import { getDataSources } from '../../api';
import DataGraph from '../../DataGraph';

// Data Graph tab of the operator console. Consultants set up each data source's named data graphs
// here (key, hop limit, manual links, edge decisions); customers only pick one per subset source
// in the TDM subset editor. The Data Graph pages read the data-source list and the read-only flag
// from AppContext, which the console shell does not provide (it renders above <App>), so this
// screen supplies them: the sources from the same list call the app makes, and editing for admins
// only — the platform refuses graph writes from anyone else.
const DataGraphScreen = ({ isAdmin }) => {
  const [connections, setConnections] = useState([]);
  const [tdmEnabled, setTdmEnabled] = useState(null);   // null until the deployment answers
  const [error, setError] = useState(null);

  const loadConnectionsHandler = useCallback(async () => {
    const rows = await getDataSources();
    setConnections(Array.isArray(rows) ? rows : []);
  }, []);

  useEffect(() => {
    let alive = true;
    // /api/v1/graph/** is off with the c2.tdm.enabled flag; an unreadable flag tries anyway.
    API.get('api', '/api/config/deployment')
      .then((d) => { if (alive) setTdmEnabled(d ? d.tdmEnabled === true : true); })
      .catch(() => { if (alive) setTdmEnabled(true); });
    loadConnectionsHandler().catch((e) => { if (alive) setError((e && e.message) || 'Could not load the data sources'); });
    return () => { alive = false; };
  }, [loadConnectionsHandler]);

  if (tdmEnabled === null) return null;
  if (!tdmEnabled) {
    return (
      <div data-testid='adv-data-graph-off'>
        <h1 className='adv-config-screen-title'>Data Graph</h1>
        <p className='adv-config-screen-desc'>
          Test Data Management is turned off on this deployment (c2.tdm.enabled), and data graphs with it.
        </p>
      </div>
    );
  }
  return (
    <AppContext.Provider value={{
      rulesList: [], integrations: [], profileEnabled: true,
      connections, loadConnectionsHandler, isAdmin: Boolean(isAdmin), isReadOnly: !isAdmin, tdmEnabled: true,
    }}>
      {error && <div className='adv-config-warning' data-testid='adv-data-graph-error'>{error}</div>}
      <DataGraph />
    </AppContext.Provider>
  );
};

export default DataGraphScreen;
